import * as Sentry from '@sentry/react';
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
  useRoutes
} from "react-router-dom";

declare global {
    interface Window {
        __SKIMMER_SENTRY_CONFIG__ : {
            dsn: string;
            environment: string;
            debug: boolean;
            release: string;
            tracesSampleRate: number;
            replaysSessionSampleRate: number;
            replaysOnErrorSampleRate: number;
        }
    }
}

const sentryInitOptions = window.__SKIMMER_SENTRY_CONFIG__;
Sentry.init({
    dsn: sentryInitOptions.dsn,
    environment: sentryInitOptions.environment,
    sendDefaultPii: true,
    debug : sentryInitOptions.debug,
    release: sentryInitOptions.release,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
              useEffect: React.useEffect,
              useLocation,
              useNavigationType,
              createRoutesFromChildren,
              matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: sentryInitOptions.tracesSampleRate,
    replaysSessionSampleRate: sentryInitOptions.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryInitOptions.replaysOnErrorSampleRate
});
export const useSentryRoutes = Sentry.wrapUseRoutesV6(useRoutes);
